<template>
	<v-container
		class="mt-2"
		:class="{
			itemDateHeadBorderDark: $vuetify.theme.isDark,
			itemDateHeadBorderLigth: !$vuetify.theme.isDark,
		}"
	>
		<v-row justify="center" v-if="globalLoading">
			<v-col cols="12" sm="10" md="9" lg="8" xl="6">
				<v-skeleton-loader type="card"></v-skeleton-loader>
			</v-col>
		</v-row>
		<v-row v-else justify="center">
			<v-col cols="12" class="text-h6">Mis Actividades</v-col>
			<v-col cols="12" class="caption">
				Haz click sobre una actividad para ver más detalle, para crear ordenes de trabajo,
				adjuntar fotográfias o documentos.
			</v-col>

			<v-col cols="12">
				Crea visitas aqui!
				<worker-lodging />
			</v-col>
			<v-col cols="12" class="caption text-center d-flex-column">
				<div class="caption font-weight-bold text--secondary my-2">
					<h2 v-if="!mountedOk">Cargando actividades...</h2>
					Use flechas para mover cronograma
				</div>
				<v-btn x-small color="info" @click.stop="moveTimeline('left')" class="mb-2">
					<v-icon small left>mdi-arrow-left</v-icon>
				</v-btn>
				<v-btn x-small color="info" @click.stop="moveTimeline('right')" class="ml-2 mb-2">
					<v-icon small right>mdi-arrow-right</v-icon>
				</v-btn>
			</v-col>
			<v-col cols="12" sm="7" class="my-1 py-0 text-left" v-if="!verifyToken()">
				<v-btn
					x-small
					color="info"
					target="_blank"
					style="border-radius: 0px;  color: white;"
					@click="loginCalendar()"
				>
					Iniciar sesión en google calendar
				</v-btn>
			</v-col>
			<v-col cols="12" sm="7" class="my-0 py-0">
				<v-checkbox @change="e => setToday(e)" label="Ver actividades de hoy"></v-checkbox>
			</v-col>

			<v-col cols="12" sm="7" class="my-0 py-0">
				<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							solo
							dense
							outlined
							filled
							readonly
							small
							persistent-hint
							hint="Mes a trabajar"
							v-bind="attrs"
							v-on="on"
							:value="monthFormatted"
						/>
					</template>
					<v-date-picker
						v-model="month"
						@change="menu = false"
						no-title
						type="month"
						locale="es"
					/>
				</v-menu>
			</v-col>
			<v-col
				cols="12"
				sm="7"
				class="my-0 py-0"
				v-if="lodgingsOfPerson.some(place => hasLodgings(place.lodgings))"
			>
				<v-menu
					ref="menu"
					v-model="menuDay"
					:close-on-content-click="false"
					:return-value.sync="selectedDay"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="selectedDay"
							dense
							filled
							readonly
							clearable
							solo
							outlined
							persistent-hint
							hint="Filtrar por dia"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="selectedDay" outlined locale="es" no-title scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menuDay = false">Cancelar</v-btn>
						<v-btn text color="primary" @click="$refs.menu.save(selectedDay)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="7" class="my-0 py-0">
				<v-text-field
					dense
					filled
					solo
					outlined
					persistent-hint
					append-icon="mdi-magnify"
					hint="Filtro lugares"
					v-model="filter1"
				/>
			</v-col>

			<v-col cols="12" sm="10" md="9" class="overflow-x-auto">
				Selecione un item vacio para ver el lugar planificado
				<b v-if="displayPlace">
					<br />
					Lugar seleccionado: {{ displayPlace }}
				</b>
				<div id="rowDates" class="overflow-x-auto" v-if="!selectedDay">
					<div v-scroll:#rowDates="onScrollDate">
						<div class="d-inline-flex">
							<div
								v-for="(date, idRangeDate) in rangeDateTable"
								:key="idRangeDate + 'idRangeDate1'"
								class="itemMonthHead"
							>
								<div
									v-if="date.nameDay == '01'"
									style="width: 150px"
									class="nameMonth pa-1 title-place"
								>
									{{ convertDate(date.numberDay) }}
								</div>
							</div>
						</div>
						<!-- Inicial del dia -->
						<div class="d-inline-flex">
							<div
								v-for="(date, idRangeDate) in rangeDateTable"
								:key="idRangeDate + 'idRangeDate2'"
								class="itemDateHead itemInitialDay"
								:class="{
									itemDateHeadBorderDark: $vuetify.theme.isDark,
									itemDateHeadBorderLigth: !$vuetify.theme.isDark,
								}"
							>
								{{ date.initialDay }}
							</div>
						</div>
					</div>
					<!-- Dias del mes -->
					<div class="d-inline-flex">
						<div
							v-for="(date, idRangeDate) in rangeDateTable"
							:key="idRangeDate + 'idRangeDate3'"
							class="itemDateHead"
							:class="{
								itemDateHeadBorderDark: $vuetify.theme.isDark,
								itemDateHeadBorderLigth: !$vuetify.theme.isDark,
							}"
						>
							{{ date.nameDay }}
						</div>
					</div>
				</div>

				<div
					style="max-height: 400px;"
					class="overflow-x-auto"
					id="scrollActivities"
					v-if="!selectedDay"
				>
					<div
						v-scroll:#scrollActivities="onScroll"
						v-for="(place, indexLodging) in placesSort"
						:key="indexLodging + 'indexLodging1'"
						class="text-left"
					>
						<template v-if="hasLodgings(place.lodgings)">
							<v-btn
								v-if="verifyToken()"
								x-small
								color="info"
								@click="syncPlace(place)"
								style="border-radius: 0px;  color: white;"
							>
								Sincronizar GCalendar
							</v-btn>
							<span class="font-weight-bold"> {{ place.name }} </span>
							<!-- Items del mes sin usar o usados -->
							<div class="d-inline-flex">
								<div
									v-for="(date, indexDate) in rangeDateTable"
									:key="indexDate + 'indexDate'"
									:class="{
										itemDateHeadBorderDark: $vuetify.theme.isDark,
										itemDateHeadBorderLigth: !$vuetify.theme.isDark,
										itemEmptySelected: verifyItemEmpty({
											profile: userProfile,
											date,
										}),
									}"
									@click="displayPlace = place.name"
									class="itemEmpty"
								>
									<div
										v-for="(lod, indexLod) in place.lodgings"
										:key="indexLod + 'indexLod'"
									>
										<div
											class="pointer "
											:class="
												itemClassUsed({
													start: lod.start,
													end: lod.end,
													dayTable: date.numberDay,
													id: lod._id,
												})
											"
											@click="openLodging(lod, place._id)"
										>
											<div style="width: max-content;">
												<div
													v-if="
														compareDates({
															text: true,
															start: lod.start,
															end: lod.end,
															dayTable: date.numberDay,
														})
													"
													class="textIntoDIV"
												>
													{{ lod.room.substring(0, 2) }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<!-- Espacio de filtraje dia y lugar -->
				<div style="max-height: 400px;" id="scrollActivities" v-else>
					<h3 class="title-place pa-1" v-if="!placesSort.length">Sin actividades :(</h3>
					<div
						v-scroll:#scrollActivities="onScroll"
						v-for="(place, indexLodging) in placesSort"
						:key="indexLodging + 'indexLodging1'"
						class="text-left"
					>
						<template v-if="hasLodgings(place.lodgings)">
							<div>
								<span class="font-weight-bold">
									{{ place.name }}
								</span>
							</div>
							<!-- Items del mes sin usar o usados -->
							<div>
								<div
									v-for="(date, indexDate) in rangeDateTable"
									:key="indexDate + 'indexDate'"
									:class="{
										itemDateHeadBorderDark: $vuetify.theme.isDark,
										itemDateHeadBorderLigth: !$vuetify.theme.isDark,
										itemEmptySelected: verifyItemEmpty({
											profile: userProfile,
											date,
										}),
									}"
									class="itemEmpty"
								>
									<template v-if="filterLodgings(place).length">
										<template v-for="(lod, indexLod) in filterLodgings(place)">
											<div
												top
												:key="indexLod + 'indexLod'"
												v-if="filterLodgings(place).length !== 0"
											>
												<div
													class="pointer "
													:class="
														itemClassUsed({
															start: lod.start,
															end: lod.end,
															dayTable: date.numberDay,
															id: lod._id,
														})
													"
													@click="openLodging(lod, place._id)"
												>
													<div style="width: max-content;">
														<div
															v-if="
																compareDates({
																	text: true,
																	start: lod.start,
																	end: lod.end,
																	dayTable: date.numberDay,
																})
															"
															class="textIntoDIV"
														>
															{{ lod.room.substring(0, 2) }}
														</div>
													</div>
												</div>
											</div>
										</template>
									</template>
									<span v-else>Sin actividades</span>
								</div>
							</div>
						</template>
					</div>
				</div>
			</v-col>
			<v-col cols="12" sm="10" md="9" class="overflow-x-auto">
				<DataEmpty
					v-if="!lodgingsOfPerson.some(place => hasLodgings(place.lodgings))"
					msj="Sin actividades programadas."
				/>
			</v-col>
		</v-row>
		<v-row justify="center" class="mt-10 mx-4" v-if="lodgingSelect">
			<v-col cols="12" sm="10" md="9" lg="8" xl="6">
				<div class="subtitle-2" ref="LodgingTabsId">
					<b>{{ lodgingSelect.group }}</b> - {{ lodgingSelect.room }} <br />Actividad
					desde el {{ lodgingSelect.start }} al {{ lodgingSelect.end }}
				</div>
				<v-btn small class="my-1 mr-1" color="accent" @click="dialogDocument = true">
					Agregar archivo
					<v-icon right>mdi-plus</v-icon>
				</v-btn>
				<!-- se creo ot responsiva -->
				<v-btn
					v-show="false"
					small
					class="mr-1 my-1"
					color="accent"
					:to="`/nueva-orden-de-trabajo/lusazu/?idLodging=${lodgingSelect._id}`"
				>
					OT Plagas
					<v-icon right>mdi-plus</v-icon>
				</v-btn>
				<lodging-tabs />
			</v-col>
		</v-row>
		<v-dialog v-if="lodgingSelect" v-model="dialogDocument" max-width="550">
			<upload-documents
				:close="() => (dialogDocument = false)"
				:viewFinal="() => null"
				:id="lodgingSelect._id"
			/>
		</v-dialog>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
let moment = extendMoment(Moment);
export default {
	name: 'TimelinePerson',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		LodgingTabs: () => import('@/components/lodgings/LodgingTabs'),
		WorkerLodging: () => import('@/components/lodgings/WorkerLodging'),
		UploadDocuments: () => import('@/components/persons/UploadDocuments'),
	},
	data() {
		return {
			displayLodToday: false,
			mountedOk: false,
			displayPlace: '',
			containerScroll: null,
			moveTimelineNumber: 0,
			bottomsheet: false,
			idSelectedLodging: '',
			setPlaceSelect: '',
			idSelectedPlace: '',
			menu: false,
			month: null,
			menuDay: null,
			selectedDay: null,
			filter1: '',
			dialogDocument: false,
		};
	},
	computed: {
		monthFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		filterPersons() {
			let personSet = new Set();
			let person = [];
			if (!personSet.has(...this.persons.filter(p => p._id == this.userProfile.idPerson)))
				personSet.add(...this.persons.filter(p => p._id == this.userProfile.idPerson));
			personSet.forEach(item => {
				if (item) person.push(item);
			});
			return person;
		},
		rangeDateTable() {
			let dates = [];
			let numberDays;
			if (this.selectedDay) {
				numberDays = 0;
				dates.push({
					numberDay: moment(this.selectedDay).format('YYYY-MM-DD'),
					nameDay: moment(this.selectedDay).format('DD'),
					initialDay: moment(this.selectedDay).format('dd'),
					dateMoment: moment(this.selectedDay),
				});
			} else {
				numberDays = this.rangeDate.end.diff(this.rangeDate.start, 'days');
				for (let i = 0; i <= numberDays; i++)
					dates.push({
						numberDay: moment(this.rangeDate.start)
							.add(i, 'day')
							.format('YYYY-MM-DD'),
						nameDay: moment(this.rangeDate.start)
							.add(i, 'day')
							.format('DD'),
						initialDay: moment(this.rangeDate.start)
							.add(i, 'day')
							.format('dd'),
						dateMoment: moment(this.rangeDate.start).add(i, 'day'),
					});
			}
			return dates;
		},
		placesSort() {
			let places = this.lodgingsOfPerson.filter(place => {
				let filter1 = true;
				if (this.filter1) {
					filter1 = place.name.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1;
				}
				if (this.selectedDay) {
					filter1 = this.filterLodgings(place).length !== 0;
				}
				return filter1;
			});
			const sortedByPeriod = places.sort((placeA, placeB) => {
				if (this.selectedDay) {
					const findLodgingA = placeA.lodgings.find(
						lodging => lodging.start === this.selectedDay
					);
					const findLodgingB = placeB.lodgings.find(
						lodging => lodging.start === this.selectedDay
					);
					return (
						moment(findLodgingA.group, 'HH:mm') - moment(findLodgingB.group, 'HH:mm')
					);
				}
				return (
					moment(placeB.lodgings[0].group, 'HH:mm') -
					moment(placeA.lodgings[0].group, 'HH:mm')
				);
			});
			return sortedByPeriod;
		},
		...mapGetters({
			globalLoading: 'User/globalLoading',
			person: 'Person/person',
			lodgingSelect: 'Lodging/lodgingSelect',
			itemEmpty: 'Lodging/itemEmpty',
			lodgingWithProblems: 'Lodging/lodgingWithProblems',
			rangeDate: 'Lodging/rangeDate',
			lodgingsOfPerson: 'Lodging/lodgingsOfPerson',
		}),
	},
	created() {
		this.month = moment()
			.date(1)
			.format('YYYY-MM');
		this.setRangeDate({
			start: moment().date(1),
			end: moment()
				.clone()
				.endOf('month'),
		});
	},
	mounted() {
		setTimeout(() => (this.mountedOk = true), 500);
	},
	methods: {
		verifyToken() {
			if (localStorage.calendarToken) {
				const expiryDate = new Date(JSON.parse(localStorage.calendarToken)['expiry_date']);
				return moment(expiryDate).isAfter(moment());
			} else return false;
		},
		async loginCalendar() {
			const url = await this.getAuthUrl();
			window.open(url, '_blank');
			return url;
		},
		async syncPlace(place) {
			this.loading = true;
			await this.syncPlaceCalendar({
				place: place._id,
			});
		},
		setToday(e) {
			if (e) this.selectedDay = moment().format('YYYY-MM-DD');
			else this.selectedDay = '';
		},
		filterLodgings(place) {
			return place.lodgings.filter(
				lod =>
					moment(this.selectedDay).isBetween(moment(lod.start), moment(lod.end), 'day') ||
					moment(this.selectedDay).isSame(lod.start) ||
					moment(this.selectedDay).isSame(lod.end)
			);
		},
		onScroll(e) {
			this.containerScroll = this.$el.querySelector('#rowDates');
			if (this.containerScroll && e.target)
				this.containerScroll.scrollLeft = e.target.scrollLeft;
		},
		onScrollDate(e) {
			this.containerScroll = this.$el.querySelector('#scrollActivities');
			if (this.containerScroll && e.target)
				this.containerScroll.scrollLeft = e.target.scrollLeft;
		},
		moveTimeline(dir) {
			if (dir == 'left' && this.moveTimelineNumber >= 50)
				this.moveTimelineNumber = this.moveTimelineNumber - 50;
			if (dir == 'right' && this.moveTimelineNumber < 650)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			if (dir == 'right' && this.moveTimelineNumber < 450)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			this.containerScroll = this.$el.querySelector('#rowDates');
			if (this.containerScroll) this.containerScroll.scrollLeft = this.moveTimelineNumber;
			this.containerScroll = this.$el.querySelector('#scrollActivities');
			if (this.containerScroll) this.containerScroll.scrollLeft = this.moveTimelineNumber;
		},
		openLodging(lodging, idPlace) {
			this.idSelectedLodging = lodging._id;
			this.idSelectedPlace = idPlace;
			this.setLodgingSelect(lodging);
			setTimeout(() => {
				var element = this.$refs.LodgingTabsId;
				var top = element.offsetTop;
				window.scrollTo(0, top);
			}, 500);
		},
		closeLodging() {
			this.idSelectedLodging = '';
			this.idSelectedPlace = '';
			this.setLodgingSelect(null);
		},
		hasLodgings(lodging) {
			return lodging.some(
				l =>
					(moment(l.start).isBefore(moment(this.rangeDate.start)) &&
						moment(l.end).isSameOrAfter(moment(this.rangeDate.start))) ||
					(moment(l.end).isAfter(moment(this.rangeDate.end)) &&
						moment(l.start).isSameOrBefore(moment(this.rangeDate.end))) ||
					(moment(l.start).isSameOrAfter(moment(this.rangeDate.start)) &&
						moment(l.end).isSameOrBefore(moment(this.rangeDate.end)))
			);
		},
		itemClassUsed(payload) {
			let otOK = false;
			if (payload.ot) otOK = payload.ot.length ? true : false;
			return {
				itemUsed: this.compareDates({
					start: payload.start,
					end: payload.end,
					dayTable: payload.dayTable,
				}),
				borderFirstItemConOT:
					otOK &&
					this.compareDates({
						text: true,
						start: payload.start,
						end: payload.end,
						dayTable: payload.dayTable,
					}),
				borderFirstItemSinOT:
					!otOK &&
					this.compareDates({
						text: true,
						start: payload.start,
						end: payload.end,
						dayTable: payload.dayTable,
					}),
				itemUsedSelected: payload.id == this.idSelectedLodging,
			};
		},
		verifyItemEmpty(payload) {
			if (this.itemEmpty) {
				return (
					payload.idPerson == this.itemEmpty.person._id &&
					payload.date.numberDay == this.itemEmpty.date.numberDay
				);
			} else return false;
		},
		selectPeriod(period) {
			if (this.periodSelected == period) this.periodSelected = null;
			else this.periodSelected = period;
		},
		getPeriod(payload) {
			let rsp = {};
			this.periods.forEach((item, i) => {
				if (item._id == payload) {
					rsp.index = i;
					rsp.name = item.name;
				}
			});
			return rsp;
		},
		compareDates(payload) {
			if (payload.text) {
				return moment(payload.dayTable).isSame(moment(payload.start));
			} else {
				return (
					moment(payload.dayTable).isSameOrAfter(moment(payload.start)) &&
					moment(payload.dayTable).isSameOrBefore(moment(payload.end))
				);
			}
		},
		// compareDates(payload) {
		// 	if (payload.text) {
		// 		return moment(payload.dayTable).isSame(moment(payload.start));
		// 	} else {
		// 		if (payload.period) {
		// 			return moment(payload.dayTable).isSame(moment(payload.start));
		// 		} else
		// 			return (
		// 				moment(payload.dayTable).isSameOrAfter(moment(payload.start)) &&
		// 				moment(payload.dayTable).isSameOrBefore(moment(payload.end))
		// 			);
		// 	}
		// },
		convertDate(value) {
			return moment(value).format('MMMM YYYY');
		},
		...mapMutations({
			selectItemEmpty: 'Lodging/selectItemEmpty',
			setModeEdit: 'Lodging/setModeEdit',
			setRangeDate: 'Lodging/setRangeDate',
			setLodgingSelect: 'Lodging/setLodgingSelect',
		}),
		...mapActions({
			syncPlaceCalendar: 'Calendar/syncPlace',
			getAuthUrl: 'Calendar/login',
		}),
	},
	watch: {
		month(newVal) {
			this.setRangeDate({
				start: moment(newVal).date(1),
				end: moment(newVal)
					.clone()
					.endOf('month'),
			});
		},
		lodgingsOfPerson(newValue) {
			if (newValue && this.lodgingSelect) {
				const place = newValue.find(item => item._id == this.idSelectedPlace);
				const lodging = place.lodgings.find(lod => lod._id == this.idSelectedLodging);
				this.setLodgingSelect(lodging);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.title-no-act {
	font-size: 12px;
	border-radius: 3px 0xp 0xp 3px;
	font-weight: 600;
	background-color: orange;
	color: white;
}

.title-place {
	font-size: 12px;
	font-weight: 600;
	border-radius: 0px 3px 3px 0px;
	background-color: gray;
	color: white;
}
.ifTodayQuestion {
	width: 24px;
	height: 19px;
	color: white;
	margin-right: 41px;
	border-radius: 25px;
	box-shadow: 0px 2px 7px -1px rgba(0, 0, 0, 0.75);
}
.itemPersonAvalaible {
	height: 20px;
	margin-left: 5px;
	background-color: #68de2c1a;
	border: 1px solid #68de2c91;
	border-radius: 15px;
	font-size: 10px;
	color: #3c9e0a;
}
.textIntoDIV {
	text-align: left;
	padding-left: 5px;
	position: sticky;
	z-index: 2;
	line-height: 13px;
}
.itemEmpty:hover {
	background-color: #80808040 !important;
}
.itemEmptySelected {
	background-color: #8080809c !important;
}
.itemWithProblems {
	background-color: #f43737bd !important;
}
.itemUsedSelected {
	background-color: #6119fb73 !important;
	color: white !important;
	border-left: none;
}
.itemTotal div {
	display: inline-block;
	width: 40%;
	height: 40px;
}
.itemNamePeriodSelect {
	background-color: #238cebc7 !important;
}
.marginTopLaterals {
	margin-top: 82px;
}
.itemNamePeriod {
	height: 20px;
	background-color: #a786fd7d;
	margin-left: 3px;
}
.itemUsedPeriod {
	width: calc(30%);
	height: 100%;
	background-color: #a786fd7d;
}
.itemTotal {
	height: 40px;
	width: 200px;
	background-color: #8080801c;
	text-align: left;
	padding-left: 15px;
	padding-right: 15px;
	margin-bottom: 6px;
}
.itemPerson {
	height: 40px;
	width: max-content;
	background-color: #8080801c;
	text-align: left;
	padding-left: 15px;
	padding-right: 15px;
	margin-bottom: 6px;
}
.itemMonthHead {
	height: 20px;
	width: 60px;
	background-color: transparent;
}
.nameMonth {
	width: 300px;
	text-align: left;
}
.itemUsedPeriod,
.itemUsed,
.itemNamePeriod,
.itemEmpty,
.itemDateHead,
.itemPerson {
	border-radius: 0px;
	border-right: 1px solid transparent;
	margin-right: 2px;
}
.itemUsed {
	width: calc(100%);
	height: 14px;
	background-color: #838383;
	float: right;
	color: white;
	font-size: 11px;
	box-shadow: 0px 1px 6px -2px black;
	margin-bottom: 2px;
}
.borderFirstItemSinOT {
	margin-left: 5px;
	border-left: 4px solid #fb1919 !important;
}
.borderFirstItemConOT {
	margin-left: 5px;
	border-left: 4px solid #0fa13b !important;
}
.itemEmpty {
	height: 60px;
	width: 60px;
	background-color: #477a8621;
	border-right: 1px solid white;
	padding-top: 5px;
}
.itemDateHeadBorderDark {
	background-color: #2d2d2d9c;
}

.itemDateHead {
	width: 60px;
	height: 20px;
}
</style>
